import React from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const Footer = ({ t, ...props }) => {
  const history = useHistory();
  return (
    <div className="footer">
      <div className="footer-left">
        &copy; {window.configs.FOOTER_SIGNATURE}
      </div>

      <div className="footer-right">
        <ul>
          <li>
            <StyledA
              href="https://smartscanmonitoring.com/customer-support/"
              target="_blank"
            >
              {t('FAQ')}/{t('Support')}
            </StyledA>
          </li>
          <li>
            <StyledA onClick={() => history.push('/help')}>{t('Help')}</StyledA>
          </li>
          <li>
            <StyledA href="mailto:support@smartscanmonitoring.com">
              {t('Contact')}
            </StyledA>
          </li>
        </ul>
      </div>
    </div>
  );
};

const StyledA = (props) => (
  <a {...props} className="footer-link">
    {props.children}
  </a>
);

export default withTranslation('app')(Footer);
